import { Expose } from "class-transformer";

export class AssignRoleToEmployeeDocumentCategoriesDto {
  @Expose()
  categoryIds: string[];

  @Expose()
  roleId: string;
}
